import { sanitize } from 'dompurify';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import OrderItem from "../../api/models/addOnTesting/ShoppingCart";

interface PanelDetailProps {
  panel: OrderItem
  onAdd?: () => void
  onRemove?: () => void
  onClose: () => void
}

export const PanelDetail = (props: PanelDetailProps) => {
  const { t } = useTranslation()
  const panel = props.panel

  return (<>
    <h2 className="text-center">{panel.name} ${panel.itemPrice}</h2>
    {!panel.limsorderedAt && props.onAdd && <Button onClick={props.onAdd} type="submit">{t("shoppingCart.addToCart")}</Button>}
    {!panel.limsorderedAt && props.onRemove && <Button onClick={props.onRemove} type="submit">{t("shoppingCart.removeFromCart")}</Button>}
    <div dangerouslySetInnerHTML={{ __html: sanitize(panel.description ?? "")}}></div>
    <Button variant="secondary" onClick={props.onClose}>{t("shoppingCart.back")}</Button>
  </>)
}
